import {PureComponent} from 'react';
import classnames from 'classnames';

class ErrorMessages extends PureComponent {
  errorMessages = {
    default: {
      // This will default to generic messages
      default: 'Please try again later.',
      Unauthorized: 'Please try again later.',
    },
    email: {
      Unauthorized: 'Error! Please check your email and password.',
    },
    phone: {
      default: 'Please try again later.',
      'not found': 'Could not find that phone number.',
      'phone has already been taken': 'Phone number has already been taken.',
      'Phone number not provisioned with any carrier': 'Could not find that phone number.',
    },
  };

  generateMessageFromError(err) {
    const errorSet = this.errorMessages[this.props.errorSet];

    const errorData = (err && err.data && err.data.json) || {};
    const {errors = {}, user_status: userStatus} = errorData;
    const reason = errors && errors.reasons && errors.reasons[0];

    // Errors do not have a standard format so we try to parse the message and display a formatted one
    const statusErrorMessage = errorSet[userStatus] || userStatus;
    const reasonErrorMessage = errorSet[reason] || reason;
    const genericMessage = errorSet[err.message] || errorSet.default || err.message;

    return statusErrorMessage || reasonErrorMessage || genericMessage;
  }

  render() {
    const classNames = classnames({
      atom: true,
      errorMessage: true,
    });

    if (!this.props.errors.length) {
      return false;
    }

    return (
      <ul className={classNames}>
        {this.props.errors.map((err) => {
          const errorMsg = typeof err === 'string' ? err : this.generateMessageFromError(err);
          return <li key={`error-${errorMsg}`}>{errorMsg}</li>;
        })}
      </ul>
    );
  }
}

ErrorMessages.defaultProps = {
  errors: [],
  errorSet: 'default',
};

export default ErrorMessages;
